import { pptUrl } from "@/constants/home";
import { statTrack } from "@/utils/mtstat";
import IconFont from "@meitu/xdesign-icon-font";
import styles from "./index.module.css";
import React from "react";

const ExperienceEntrance = () => {
  return (
    <div className={styles.experienceEntrance}>
      <div className={styles.inner}>
        <div className={styles.title}>全新的PPT生成方式</div>
        <div className={styles.desc}>
          革新生成技术，一键创作精美PPT，为你节省90%时间，让创意自由流淌。
        </div>
        <a
          className={styles.btn}
          href={pptUrl}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            statTrack("tools_click_ppt_home", {
              click_type: "intro_create",
              intro_create_button: "start_experience",
            });
            setTimeout(() => {
              window.location.href = pptUrl;
            }, 100);
          }}
        >
          开始体验
          <IconFont
            name="ArrowRightBold"
            color="#fff"
            fontSize={22}
            className={styles.btnIcon}
          />
        </a>
      </div>
    </div>
  );
};

export default React.memo(ExperienceEntrance);
